import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";

import { CheckedItem } from "@/components/atoms";
import { useAuth } from "@/shared/hooks";

import { StyledPanel } from "../../styled";

const LoginPanel: FC = () => {
    const { t } = useTranslation();
    const { logout } = useAuth();

    return (
        <StyledPanel $color="var(--color-primary-light)">
            <Typography fontSize="var(--size-24)" color="var(--color-primary)" fontWeight="bold" textAlign="center">
                {t("SuccessPage.AccessYourCustomerZone")}
            </Typography>
            <Typography color="var(--color-grey-900)" textAlign="center">
                {t("SuccessPage.AccessYourCustomerZoneInfo")}
            </Typography>
            <ul>
                <li>
                    <CheckedItem title={t("SuccessPage.AccessYourCustomerZoneItem1")} />
                </li>
                <li>
                    <CheckedItem title={t("SuccessPage.AccessYourCustomerZoneItem2")} />
                </li>
                <li>
                    <CheckedItem title={t("SuccessPage.AccessYourCustomerZoneItem3")} />
                </li>
                <li>
                    <CheckedItem title={t("SuccessPage.AccessYourCustomerZoneItem4")} />
                </li>
            </ul>
            <Button style={{ maxWidth: "200px" }} fullWidth onClick={logout}>
                {t("Common.SignUp")}
            </Button>
        </StyledPanel>
    );
};

export default LoginPanel;
